<template>
  <v-app-bar-nav-icon color="#1b5e20">
    <div class="text-center">
      <v-dialog v-model="progressBar" width="100" hide-overlay>
        <v-progress-circular
          :size="60"
          color="primary"
          indeterminate
          align-center
          justify-center
        >
        </v-progress-circular>
      </v-dialog>
    </div>
    <v-btn @click.stop="drawer = !drawer" icon color="#1b5e20" large>
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <div class="text-center">
      <v-dialog v-model="dialogLicence" max-width="500">
        <v-card color="#1b5e20">
          <v-col class="text-right">
            <v-btn
              icon
              rounded
              color="white"
              outlined
              elevation="5"
              large
              @click="dialogLicence = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-card max-height="400" max-width="500" color="white">
            <v-container fluid>
              <v-form ref="formLicence" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="licence"
                  label="Licence"
                  placeholder="input licence"
                  length="6"
                >
                </v-text-field>
              </v-form>
              <v-card-actions>
                <v-btn color="#1b5e20" @click="saveLicence" class="white--text">
                  OK
                  <v-icon right color="white">mdi-key</v-icon>
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-card>
      </v-dialog>
    </div>
    <v-navigation-drawer
      v-model="drawer"
      app
      color="#1b5e20"
      padless
      mini-variant
      mini-variant-width="200"
    >
      <v-avatar color="white" size="50">
        <img
          :src="getImage('/' + setting.logo_path_url)"
          height="100px"
          width="100px"
          contain
          @click="admin"
        />
      </v-avatar>

      <v-list flat class="mt-0">
        <v-tooltip right color="info">
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              :color="getColor(user.member_id)"
              dark
              v-bind="attrs"
              v-on="on"
              @click="isLicence"
            >
              <span class="black--text">
                <v-text v-if="user.member_id == 1">PLATINUM</v-text>
                <v-text v-else-if="user.member_id == 2">GOLD</v-text>
                <v-text v-else-if="user.member_id == 3">SILVER</v-text>
                <v-text v-else>FREE</v-text>
              </span>
            </v-chip>
          </template>
          <span>Your license</span>
        </v-tooltip>

        <v-list-item-group v-model="selectedItem">
          <v-list-item
            v-for="(item, i) in user.roles == 'ADMIN' ? items : items_staff"
            :key="i"
            :to="item.route"
            active-class="border"
            :ripple="false"
          >
            <v-list-item-content>
              <v-chip style="background-color: white">
                <v-icon
                  v-text="item.icon"
                  class="py-2 white--text"
                  icon
                  rounded
                  color="green"
                  outlined
                  elevation="5"
                  size="large"
                ></v-icon>
                <v-list-item-title v-text="item.text" class="mt-3 caption">
                </v-list-item-title>

                <v-badge
                  :content="countOrderViewed"
                  color="orange"
                  v-if="countOrderViewed != 0 && item.text == 'Orders'"
                >
                </v-badge>
              </v-chip>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-app-bar-nav-icon>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    dialogLicence: false,
    selectedItem: 0,
    drawer: true,
    items: [
      { icon: "fas fa-solid fa-cash-register", text: "Cashier", route: "/" },
      { icon: "fas fa-address-book", text: "Users", route: "/users" },
      {
        icon: "fas fa-cart-arrow-down",
        text: "Purchase Orders",
        route: "/purchase-order",
      },
      { icon: "fas fa-table", text: "Categories", route: "/categories" },
      { icon: "fas fa-table", text: "Products", route: "/products" },
      { icon: "fas fa-shop", text: "Orders", route: "/my-order" },
      { icon: "fas fa-percent", text: "Promotions", route: "/promotion" },
      { icon: "fas fa-calculator", text: "Cashflow", route: "/cashflow" },
      // { icon: 'fas fa-chart-bar', text: 'Profit Orders', route: '/profit-order' },

      { icon: "fas fa-chart-line", text: "Chart Profit", route: "/chart-profit" },
      { icon: "fas fa-cog", text: "Store Setting", route: "/store-setting" },
      { icon: "fas fa-info", text: "Information", route: "/information" },
      { icon: "mdi-truck-delivery-outline", text: "Courier", route: "/courier" },
      { icon: "fas fa-key", text: "Licence", route: "/licence" },
      { icon: "mdi-code-array", text: "Code Referal Iot", route: "/code-referal-iot" },
    ],
    items_staff: [
      { icon: "fas fa-solid fa-cash-register", text: "Cashier", route: "/" },
      { icon: "fas fa-address-book", text: "Users", route: "/users" },
      {
        icon: "fas fa-cart-arrow-down",
        text: "Purchase Orders",
        route: "/purchase-order",
      },
      { icon: "fas fa-table", text: "Categories", route: "/categories" },
      { icon: "fas fa-table", text: "Products", route: "/products" },
      { icon: "fas fa-shop", text: "Orders", route: "/my-order" },
      { icon: "fas fa-percent", text: "Promotions", route: "/promotion" },
      { icon: "fas fa-calculator", text: "Cashflow", route: "/cashflow" },
      // { icon: 'fas fa-chart-bar', text: 'Profit Orders', route: '/profit-order' },
      // { icon: 'fas fa-chart-bar', text: 'Profit Products', route: '/profit-product' },
      { icon: "fas fa-chart-line", text: "Chart Profit", route: "/chart-profit" },
      { icon: "fas fa-cog", text: "Store Setting", route: "/store-setting" },
      { icon: "mdi-truck-delivery-outline", text: "Courier", route: "/courier" },
      // { icon: "mdi-code-array", text: "Code Referal Iot", route: "/code-referal-iot" },
    ],

    store: "",
    licence: "",
    progressBar: false,
    countOrderViewed: 0,
  }),
  computed: {
    ...mapGetters({
      user: "auth/user",
      setting: "setting/setting",
    }),
  },

  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
      setSetting: "setting/set",
    }),
    go() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/store-setting";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.store = data;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    getCountViewed() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/orders/count-viewed";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.countOrderViewed = data;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    admin() {
      this.$router.push("/admin");
    },
    getColor(member) {
      if (member == 1) return "white";
      else if (member == 2) return "yellow";
      else if (member == 3) return "blue";
      else return "gree";
    },
    isLicence() {
      this.dialogLicence = true;
    },
    saveLicence() {
      this.progressBar = true;
      let formData = new FormData();
      formData.set("licence", this.licence);
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      this.axios
        .post("/licence/upgrade", formData, config)
        .then((response) => {
          let { data } = response;
          this.setAuth(data.data);
          this.setAlert({
            status: true,
            text: data.message,
            color: data.status,
          });
          this.dialogLicence = false;
        })
        .catch((error) => {
          let { data } = error;
          this.setAlert({
            status: true,
            text: data.message,
            color: "error",
          });
          this.isLicence();
          this.dialogLicence = false;
        });
    },
  },
  created() {
    this.getCountViewed();
    this.go();
  },
};
</script>

<style>
.border {
  margin-left: 8px;
  margin-right: 8px;
  background: #094aee;
  border-radius: 50px;
  text-decoration: none;
}

.v-list-item-group .v-list-item--active {
  color: white !important;
}

.theme--light.v-list-item--active .v-list-item__subtitle,
.theme--light.v-list-item .v-list-item__action-text {
  color: white !important;
}
</style>
